import _ from 'lodash'
import {permissionCodes,} from 'modules/permissions/contants'
import PermissionProvider from 'modules/permissions/PermissionProvider'
import React from 'react'
import {BsTrash} from 'react-icons/bs'
import {IoFolderOpenOutline, IoGridOutline, IoIdCardOutline, IoPersonOutline, IoSettingsOutline,} from 'react-icons/io5'
import {withRouter} from 'react-router-dom'
import {compose, fromRenderProps, nest, withProps} from 'recompose'
import {notFoundOnError, withAccessPermissions} from 'views/AppLocals/composers'
import {CustomKeys} from 'views/AppLocals/CustomKeys'
import {AppEntities} from 'views/AppLocals/enums'
import {createCheckPermissions} from 'views/AppLocals/factory/createCheckPermissions'
import {ContextActionTypes} from 'views/AppLocals/factory/createContextMenu'
import createDeleteEntity from 'views/AppLocals/factory/createDeleteEntity'
import {CoHosts, CoOwners} from 'views/AppLocals/factory/createHostSetting'
import {createSettingModule} from 'views/AppLocals/factory/createModule'
import Contacts from 'views/Organization/Settings/Contacts/Contacts.lazy'
import Locations from 'views/Organization/Settings/Locations/Locations.lazy'
import {SubDomainContext} from 'views/SubDomain/SubDomainContext'
import OrganizationContainerContext from '../OrganizationContainerContext'
import OrganizationSettingAbout from './OrganizationSettingAbout'
import OrganizationSettingCategories from './OrganizationSettingCategories'
import OrganizationSettingOverview from './OrganizationSettingOverview'
import OrganizationSettingPartners from './OrganizationSettingPartners'
import OrganizationSettingPhoto from './OrganizationSettingPhoto'
import OrganizationSettingProfile from './OrganizationSettingProfile'
import {RxPlus} from "react-icons/rx";
import {PiGearSix} from "react-icons/pi";
import OrganizationSettingAssociations from "./OrganizationSettingAssociations";
import {HiLink} from "react-icons/hi2";
import {TbHeartCheck, TbHeartX} from "react-icons/tb";
import {isSystemAdmin} from "../../../../helpers/authUtils";
import OrganizationSubCategories from "../../../Workspace/SubCategories/OrganizationSubCategories";
import WorkspaceMedalsList from "../../../Workspace/Medal/WorkspaceMedalsList";
import WorkspaceMedalAwardsHistory from "../../../Workspace/Medal/WorkspaceMedalAwardsHistory";

const menuItems = [
    {
        key: 'overview',
        label: 'general settings',
        icon: <IoSettingsOutline/>,
    },
    {
        key: 'profiles',
        label: 'provider profiles',
        icon: <IoFolderOpenOutline/>,
        children: [
            {
                label: 'about us',
                key: 'about-us',
            },
            {
                label: 'photos',
                key: 'photos',
            },
            {
                label: 'more information',
                key: 'profile',
            },
        ],
    },
    {
        key: 'organization_verification',
        label: 'organization verification',
        icon: <HiLink/>,
    },
    {
        key: 'category',
        label: 'categories',
        icon: <IoGridOutline/>,
        children: [
            {
                label: 'categories',
                key: 'categories',
            },
        ],
    },
    {
        key: 'location-contact',
        label: 'location & contact',
        icon: <IoIdCardOutline/>,
        children: [
            {
                label: 'location',
                key: 'location',
            },
            {
                label: 'contact',
                key: 'contact',
            },
        ],
    },
    {
        key: 'governing and subordinate units',
        label: 'governing and subordinate units',
        icon: <IoPersonOutline/>,
        children: [
            {
                label: 'governing organizations',
                key: CustomKeys.governing_organizations.name,
            },
            {
                label: 'subordinate units',
                key: CustomKeys.subordinate_units.name,
            },
        ],
    },
    {
        key: 'delete',
        label: 'delete',
        icon: <BsTrash/>,
    },
]

const routeEntities = [
    {
        path: 'overview',
        label: 'overview',
        component: createCheckPermissions([permissionCodes.canEdit])(OrganizationSettingOverview),
    },
    {
        path: 'organization_verification',
        label: 'organization verification',
        component: createCheckPermissions([permissionCodes.canEdit])(OrganizationSettingAssociations),
    },
    {
        path: 'about-us',
        label: 'about us',
        component: createCheckPermissions([permissionCodes.canEdit])(OrganizationSettingAbout),
    },
    {
        path: 'photos',
        label: 'photos',
        component: createCheckPermissions([permissionCodes.canEdit])(OrganizationSettingPhoto),
    },
    {
        path: 'categories',
        label: 'categories',
        component: createCheckPermissions([permissionCodes.canEdit])(OrganizationSettingCategories),
    },
    {
        path: 'profile',
        label: 'profile',
        component: createCheckPermissions([permissionCodes.canEdit])(OrganizationSettingProfile),
    },
    {
        path: 'location',
        label: 'location',
        component: createCheckPermissions([permissionCodes.canEdit])(Locations),
    },
    {
        path: 'contact',
        label: 'contact',
        component: createCheckPermissions([permissionCodes.canEdit])(Contacts),
    },
    {
        path: 'partners',
        label: 'partners',
        component: createCheckPermissions([permissionCodes.canEdit])(OrganizationSettingPartners),
    },
    {
        path: CustomKeys.governing_organizations.name,
        label: CustomKeys.governing_organizations.label,
        component: createCheckPermissions([permissionCodes.canEdit])(CoHosts),
    },
    {
        path: CustomKeys.subordinate_units.name,
        label: CustomKeys.subordinate_units.label,
        component: createCheckPermissions([permissionCodes.canEdit])(CoOwners),
    },
    {
        path: 'organization-categories',
        label: 'partners',
        component: createCheckPermissions([permissionCodes.canEdit])(OrganizationSubCategories),
    },
    {
        path: 'medal-list',
        label: 'partners',
        component: createCheckPermissions([permissionCodes.canEdit])(WorkspaceMedalsList),
    },
    {
        path: 'medal-rewards-history',
        label: 'partners',
        component: createCheckPermissions([permissionCodes.canEdit])(WorkspaceMedalAwardsHistory),
    },
    {
        path: 'delete',
        label: 'delete',
        component: createCheckPermissions([permissionCodes.canEdit])(({item}) => createDeleteEntity(item)),
    },
].map(({
         path,
         component: Component,
         withItem = (item) => ({item}),
         ...rest
    }) => ({
        ...rest,
        path,
        key: path,
        component: (props) => (
            <OrganizationContainerContext.Consumer>
                {({organization: item}) => (
                    <Component
                        {...(withItem(item) ?? {})}
                        {...props}
                    />
                )}
            </OrganizationContainerContext.Consumer>
        ),
    })
)

export const organizationSettings = {
    actions: [
        {
            key: ContextActionTypes.ADD_TO_RECOMMENDATION,
            label: 'add to recommendation',
            icon: <TbHeartCheck size={15} className="text-color-400"/>,
            isInvisible: ({login}) => {
                return !isSystemAdmin(login)
            }
        },
        {
            key: ContextActionTypes.REMOVE_FROM_RECOMMENDATION,
            label: 'remove from recommendation',
            icon: <TbHeartX size={15} className="text-color-400"/>,
            isInvisible: ({login}) => {
                return !isSystemAdmin(login)
            }
        },
        {
            key: ContextActionTypes.CREATE_CHANNEL,
            label: 'create channel',
            icon: <RxPlus size={13} className="text-color-400"/>,
        },
        {
            key: ContextActionTypes.CREATE_EVENT,
            label: 'create event',
            icon: <RxPlus size={13} className="text-color-400"/>,
        },
        {
            key: ContextActionTypes.SETTINGS,
            label: 'setting',
            icon: <PiGearSix size={13} className="text-color-400"/>,
        },
    ],
    menuItems,
    routeEntities,
}

const OrganizationSettings = nest(
    ({children, ...props}) => (
        <OrganizationContainerContext.Consumer>
            {({organization: item}) => (
                <PermissionProvider
                    permissions={{
                        edit: item.edit,
                        ...item.available_actions,
                    }}>
                    {children}
                </PermissionProvider>
            )}
        </OrganizationContainerContext.Consumer>
    ),
    ({id, ...props}) =>
        createSettingModule([AppEntities.ORGANIZATION], {
            item: id,
            ...props,
        })
)

export default compose(
    notFoundOnError(OrganizationContainerContext.Consumer),
    withAccessPermissions([permissionCodes.canEdit]),
    withRouter,
    fromRenderProps(SubDomainContext.Consumer, ({id}) => ({
        id,
    })),
    withProps(({id, match}) => ({
        id: id || _.get(match, 'params.id'),
    }))
)(OrganizationSettings)
